__turbopack_context__.v({
  "appHeader": "KnowledgeWorkspace-module__-IcaqW__appHeader",
  "clearButton": "KnowledgeWorkspace-module__-IcaqW__clearButton",
  "conflict": "KnowledgeWorkspace-module__-IcaqW__conflict",
  "controls": "KnowledgeWorkspace-module__-IcaqW__controls",
  "current": "KnowledgeWorkspace-module__-IcaqW__current",
  "documentDetail": "KnowledgeWorkspace-module__-IcaqW__documentDetail",
  "documentName": "KnowledgeWorkspace-module__-IcaqW__documentName",
  "emptyState": "KnowledgeWorkspace-module__-IcaqW__emptyState",
  "exampleLabel": "KnowledgeWorkspace-module__-IcaqW__exampleLabel",
  "filterControl": "KnowledgeWorkspace-module__-IcaqW__filterControl",
  "finding": "KnowledgeWorkspace-module__-IcaqW__finding",
  "overdue": "KnowledgeWorkspace-module__-IcaqW__overdue",
  "path": "KnowledgeWorkspace-module__-IcaqW__path",
  "resultCount": "KnowledgeWorkspace-module__-IcaqW__resultCount",
  "searchControl": "KnowledgeWorkspace-module__-IcaqW__searchControl",
  "status": "KnowledgeWorkspace-module__-IcaqW__status",
  "table": "KnowledgeWorkspace-module__-IcaqW__table",
  "tableScroll": "KnowledgeWorkspace-module__-IcaqW__tableScroll",
  "toolbar": "KnowledgeWorkspace-module__-IcaqW__toolbar",
  "workspace": "KnowledgeWorkspace-module__-IcaqW__workspace",
});
